export default __webpack_public_path__ + "static/spot-sti__sexual-health-free-02-9da51ff6a09257a9c089b9ba785521a8.jpg";